import api from "./config/axios-configs";
import { defineCancelApiObject } from "./config/axios-utils";
import type { CombinedReportType } from '../types/CombinedReport';

export const PoliceReportsService = {
    authenticateUser: async (email: string, password: string, cancel = false): Promise<string> => {
        const response = await api.request({
            url: `/User/Authenticate`,
            method: "POST",
            headers: {
                'accept': '*/*'
            },
            params: {
                email: email,
                password: password
            },
            signal: cancel
                ? cancelApiObject.authenticateUser.handleRequestCancellation().signal
                : undefined,
        });

        if (response.status !== 200) {
            throw new Error(`Authentication failed: ${response.statusText}`);
        }

        const data = response.data;
        return data.token;
    },
    insertUser: async (email: string, cancel = false): Promise<string> => {
        const response = await api.request({
            url: `/User/Insert`,
            method: "POST",
            headers: {
                'accept': '*/*'
            },
            params: {
                email: email,
            },
            signal: cancel
                ? cancelApiObject.insertUser.handleRequestCancellation().signal
                : undefined,
        });

        if (response.status !== 200) {
            throw new Error(`Authentication failed: ${response.statusText}`);
        }

        const data = response.data;
        return data.message;
    },
    updateUser: async (email: string, cancel = false): Promise<string> => {
        const response = await api.request({
            url: `/User/Update`,
            method: "POST",
            headers: {
                'accept': '*/*'
            },
            params: {
                email: email,
            },
            signal: cancel
                ? cancelApiObject.updateUser.handleRequestCancellation().signal
                : undefined,
        });

        if (response.status !== 200) {
            throw new Error(`Authentication failed: ${response.statusText}`);
        }

        const data = response.data;
        return data.message;
    },
    getCombinedReport: async (caseNumber: string, reportDate: Date, cancel = false): Promise<CombinedReportType> => {
        const response = await api.request({
            url: `/Report/CombinedReport`,
            method: "GET",
            params: { caseNumber, reportDate },
            signal: cancel
                ? cancelApiObject.getCombinedReport.handleRequestCancellation().signal
                : undefined,
        });

        if (response.status === 400) {
            return response.data; // Return the message if status is 400
        }

        if (response.status !== 200) {
            throw new Error(`Authentication failed: ${response.statusText}`);
        }

        const data = response.data;
        return data;
    },
    getReportCount: async (cancel = false): Promise<number> => {
        const response = await api.request({
            url: `/Report/RecordCount`,
            method: "GET",
            signal: cancel
                ? cancelApiObject.getReportCount.handleRequestCancellation().signal
                : undefined,
        });

        if (response.status !== 200) {
            throw new Error(`Authentication failed: ${response.statusText}`);
        }

        const data = response.data;
        return data;
    },
    getAccessLimit: async (cancel = false): Promise<number> => {
        const response = await api.request({
            url: `/Report/AccessLimit`,
            method: "GET",
            signal: cancel
                ? cancelApiObject.getAccessLimit.handleRequestCancellation().signal
                : undefined,
        });

        if (response.status !== 200) {
            throw new Error(`Authentication failed: ${response.statusText}`);
        }

        const data = response.data;
        return data;
    }
};

const cancelApiObject = defineCancelApiObject(PoliceReportsService);
